import { memo } from 'react';

import { ModalCloseButton, ModalTitle } from '@air/primitive-modal';

import { X_BUTTON } from '~/constants/testIDs';

type SharePrivateCanvasModalHeaderProps = {
  onClose: AirModalProps['onClose'];
};

export const SharePrivateCanvasModalHeader = memo(({ onClose }: SharePrivateCanvasModalHeaderProps) => {
  return (
    <div className="flex items-center justify-between border-b border-b-grey-5 px-8 py-6">
      <ModalTitle data-testid="SHARE_PRIVATE_CANVAS_MODAL_HEADER">Share link to canvas</ModalTitle>
      <ModalCloseButton className="shrink-0" onClick={onClose} data-testid={X_BUTTON} />
    </div>
  );
});

SharePrivateCanvasModalHeader.displayName = 'SharePrivateCanvasModalHeader';
